import React from "react";
import { Editor, Switch } from "components/fields";
import { Link } from "react-router-dom";


export default ({ form, isUtils }) => {

	return <>
		<Switch {...form} left label="Product Terms of Service"
		note={<span>Describe policy relative to this product. You can specify a general store policy in the <Link target="_blank" to="/settings/shop/general">settings</Link></span>}
				wrapperClassName={isUtils ? "pb-3" : "pb-3"} name="tos_enabled" withBorder={form.values.tos_enabled ? false : true} />

		{form.values.tos_enabled && <div className={`mb-3 ${isUtils ? 'w-100' : ''}`} style={{ borderBottom: "1px solid var(--black1)" }}>
			<Editor name="terms_of_service" {...form} />
		</div>}
	</>
}